import * as React from 'react';
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';


interface Params {
    readonly open: boolean,
    readonly text: string,
    readonly onDialogCancel: () => void,
    readonly onDialogSubmit: () => void,
    readonly onTextChanged: (text: string) => void,
}

const TimeDialog = ({open, text, intl, onDialogCancel, onDialogSubmit, onTextChanged}: Params & InjectedIntlProps) => {

    const textfieldChangedHandler: React.ChangeEventHandler<HTMLInputElement> = event => {
        onTextChanged(event.target.value);
    };

    return (
        <Dialog open={open} onClose={onDialogCancel}>
            <DialogTitle>
                <FormattedMessage id="time_dialog_title"/>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <FormattedMessage id="time_dialog_content"/>
                </DialogContentText>
                <TextField
                    autoFocus={true}
                    margin="dense"
                    id="name"
                    label={intl.formatMessage({ id: 'time_dialog_label' })}
                    fullWidth={true}
                    value={text}
                    onChange={textfieldChangedHandler}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onDialogCancel} color="primary">
                    <FormattedMessage id="cancel"/>
                </Button>
                <Button onClick={onDialogSubmit} color="primary">
                    <FormattedMessage id="ok"/>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default injectIntl(TimeDialog);


// WEBPACK FOOTER //
// ./src/components/TimeDialogView.tsx